var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "application-lock-modal",
      "footer-close-button-text": _vm.$t("global.words.cancel"),
      "modal-dialog-centered": false,
    },
    scopedSlots: _vm._u([
      {
        key: "header-custom",
        fn: function () {
          return [
            _c("div", { staticClass: "d-flex flex-wrap" }, [
              _c("div", { staticClass: "vertical-center" }, [
                _c("h5", { staticClass: "modal-title bold" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("application.actions.toggleApplicationLock")
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [_c("div", { domProps: { innerHTML: _vm._s(_vm.message) } })]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  id: "confirmation-toggle-lock-button",
                  type: "button",
                  "class-name": "btn btn-primary",
                },
                on: { click: _vm.submit },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("global.words.yes")) + "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }